<template>
	<b-list-group flush>
		<b-list-group-item>
			<h4 class="float-left">{{companion.Name}}</h4>
			<p class="lead float-right">{{companion.Type}} {{companion.Level}}</p>
		</b-list-group-item>
		<div class="p-0">
			<div class="progress">
				<div class="progress-bar bg-danger" role="progressbar" :style="{width: percentage(current.Points.Hit, stats.HP)}">HP: {{current.Points.Hit}}/{{stats.HP}}</div>
			</div>
		</div>
		<b-list-group-item class="p-1">
			<div class="row" style="padding-left: 15px!important; padding-right:15px!important;">
				<div class="col-12 col-sm-6 px-1">
					<div class="input-group">
						<div class="input-group-prepend">
							<span class="input-group-text number">HP</span>
						</div>
						<input type="number" class="form-control" v-model.number="HP" min="0" :max="stats.HP">
						<div class="input-group-append">
							<span class="input-group-text">{{stats.HP}}</span>
						</div>
					</div>
				</div>
			</div>
		</b-list-group-item>
		<b-list-group-item>
			<span class="lead pr-2">Defense</span>
			<strong>EAC</strong> {{stats.EAC}}
			<strong>KAC</strong> {{stats.KAC}}
			<strong>Fort</strong> {{ (companion.GoodSave == "Fortitude" ? stats.GoodSave : stats.PoorSave)|bonus }}
			<strong>Ref</strong> {{ (companion.GoodSave == "Reflex" ? stats.GoodSave : stats.PoorSave)|bonus }}
			<strong>Will</strong> {{ (companion.GoodSave == "Will" ? stats.GoodSave : stats.PoorSave)|bonus }}
		</b-list-group-item>
		<b-list-group-item>
			<span class="lead pr-2">Offense</span>
			<strong>Speed</strong> {{companion.Speed}}
			<ul class="list-inline" v-if="attacks.melee.length > 0">
				<li class="list-inline-item"><strong>Melee</strong></li>
				<li class="list-inline-item" v-for="(attack, index) in attacks.melee" v-bind:key="index">
					{{attack.Name}} {{stats.BAB|bonus}} ({{stats.DamageDie}}+{{stats.DamageMod+companionMod(companion, "Strength")}} {{attack.Damage}})
				</li>
			</ul>
			<ul class="list-inline" v-if="attacks.ranged.length > 0">
				<li class="list-inline-item"><strong>Ranged</strong></li>
				<li class="list-inline-item" v-for="(attack, index) in attacks.ranged" v-bind:key="index">
					{{attack.Name}} {{stats.BAB|bonus}} ({{stats.DamageDie}}+{{stats.DamageMod}} {{attack.Damage}})
				</li>
			</ul>
		</b-list-group-item>
		<b-list-group-item>
			<span class="lead">Statistics</span>
			<div>
				<span v-for="(score,ability) in companion.AbilityMods" v-bind:key="ability">
					<strong>{{ability|abbr}}</strong> {{companionMod(companion, ability)|bonus}}; 
				</span>
			</div>
		</b-list-group-item>
		<b-list-group-item>
			<p class="lead">Special Abilities</p>
			<p v-for="(special, index) in companion.Specials" v-bind:key="index">
				<b>{{special.Name}} ({{special.Type}})</b> {{special.Description}}
			</p>
		</b-list-group-item>
	</b-list-group>
</template>

<script>
export default {
	methods: {
		abilityMod: function(score) {
			return Math.floor((score - 10) / 2)
		},
		companionMod: function(companion, ability){
			var mod = companion.AbilityMods[ability];
			if(ability == companion.AbilityBest){
				mod += this.stats.AbilityModGood
			}else if(ability == companion.AbilityBetter){
				mod += this.stats.AbilityModPoor
			}
			return mod;
		},
		percentage: function(fraction, whole){
			return Math.round( (fraction/whole)*100 )+'%';
		},
	},
	computed: {
		level: function() {
			return this.$store.getters['currentLevel']
		},
		companion: function() {
			return this.$store.state.Character.Levels[ this.level ].Companion
		},
		current: function() {
			return this.$store.state.Character.Current.Companion
		},
		stats: function() {
			return this.$store.getters['character/companions/stats']
		},
		attacks: function(){
			if(this.stats !== null){
				var melee = [];
				var ranged = [];
				var attacks = this.companion.Attacks || null;
	
				if(attacks !== null){
					attacks.forEach(attack => {
						if(attack.Type == "Melee")
							melee.push(attack);
						else if(attack.Type == "Ranged")
							ranged.push(attack);
					});
				}
	
				return {
					"melee": melee,
					"ranged": ranged
				};
			}else{
				return null;
			}
			
		},
		HP: {
			get: function() {
				return this.current.Points.Hit
			},
			set: function(value) {
				return this.$store.dispatch('character/companions/setHP',value)
			}
		},
	},
}
</script>

<style scoped>

</style>